import type { FormIdentifier, FormSubmission, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { FormIdentifiersListItem } from "./FormIdentifiersListItem"

interface FormIdentifiersListProps {
	formSubmission: Stored<FormSubmission>
	formIdentifiers: Stored<FormIdentifier>[]
}

export const FormIdentifiersList = memo<FormIdentifiersListProps>((props) => {
	const { formSubmission, formIdentifiers } = props

	return (
		<div className="flex flex-col gap-2">
			{formIdentifiers.map((formIdentifier) => {
				return (
					<FormIdentifiersListItem
						key={formIdentifier.uuid}
						formSubmission={formSubmission}
						formIdentifier={formIdentifier}
					/>
				)
			})}
		</div>
	)
})
FormIdentifiersList.displayName = "FormIdentifiersList"
